module.exports = __webpack_public_path__ + "img/Group682x.58bbaadc.png";